import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-executions-stats-widget',
  standalone: true,
  imports: [CommonModule, CardModule, SkeletonModule],
  templateUrl: './executions-stats-widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExecutionsStatsWidget {
  @Input() count: number = 0;
  @Input() lastExecutionTime: Date | null = null;
  @Input() loading: boolean = false;

  getLastRunText(): string {
    if (!this.lastExecutionTime) {
      return 'No recent runs';
    }

    const now = new Date();
    const diffMs = now.getTime() - this.lastExecutionTime.getTime();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffDays > 0) {
      return `Last run: ${diffDays}d ago`;
    } else if (diffHours > 0) {
      return `Last run: ${diffHours}h ago`;
    } else if (diffMinutes > 0) {
      return `Last run: ${diffMinutes}m ago`;
    } else {
      return 'Last run: just now';
    }
  }
}
